import { render, staticRenderFns } from "./PermissionTool.vue?vue&type=template&id=50d14a16&scoped=true&"
import script from "./PermissionTool.vue?vue&type=script&lang=js&"
export * from "./PermissionTool.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTool.vue?vue&type=style&index=0&id=50d14a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d14a16",
  null
  
)

export default component.exports